module.exports = __webpack_public_path__ + "assets/img/Ram-Group-Website-w540.0a137682.jpg";